export default function () {
  const birthdayPickers = document.querySelectorAll('[data-js-bday]')

  birthdayPickers.forEach(function (birthdayPicker) {
    birthdayPicker.max = new Date().toISOString().split('T')[0]
  })
}
